import styled from "@emotion/styled";
import {
  mobileQuery,
  tabletQuery,
  laptopQuery,
  desktopQuery,
} from "../../utils/mediaqueries";
import theme from "../../utils/theme";

export const Container = styled.div(
  {
    justifyContent: "space-around",
    alignItems: "center",
    display: "flex",
    background: theme.colors.darkBlue,
    width: "100%",

    [mobileQuery]: {
      height: "55px",
    },

    [tabletQuery]: {
      height: "70px",
    },

    [laptopQuery]: {
      height: "100vh",
      flexDirection: "column",
    },

    [desktopQuery]: {
      height: "100vh",
      flexDirection: "column",
    },
  },
  ({ isIphoneX }) => ({
    [mobileQuery]: {
      paddingBottom: isIphoneX ? "20px" : 0,
    },
  }),
);
